import { THEMES } from "./themes";

export function applyThemeObject(colors, { persist = false, persistKey = "selectedTheme" } = {}) {
  const safeColors = colors || {};

  if (typeof document === "undefined") {
    return safeColors;
  }

  const root = document.documentElement;

  Object.entries(safeColors).forEach(([key, value]) => {
    if (value != null) {
      root.style.setProperty(`--${key}`, value, "important");
    }
  });

  root.style.setProperty("--bs-body-bg", safeColors.bg || "#ffffff", "important");
  root.style.setProperty("--bs-body-color", safeColors.text || "#212529", "important");
  root.style.setProperty("--bs-card-bg", safeColors.panel || "#f8f9fa", "important");
  root.style.setProperty("--bs-card-border-color", safeColors.stroke || "rgba(0,0,0,.08)", "important");
  root.style.setProperty("--bs-border-color", safeColors.stroke || "rgba(0,0,0,.08)", "important");

  if (persist && persistKey) {
    localStorage.setItem(persistKey, JSON.stringify(safeColors));
  }

  return safeColors;
}

export function applyTheme(themeKey, { persist = true } = {}) {
  const theme = THEMES[themeKey] || THEMES.classic;

  if (typeof document === "undefined") {
    return theme;
  }

  applyThemeObject(theme.colors, { persist });

  if (persist) {
    localStorage.setItem("selectedTheme", themeKey);
  }

  return theme;
}

export function applyEventTheme(config, { persist = false } = {}) {
  const theme = applyTheme(config?.theme || "classic", { persist });
  const themeColors = theme.colors || {};
  const legacyUploadPanel = config?.customTheme?.["upload-panel"];
  const uploadPanelColor = config?.uploadPanelColor || legacyUploadPanel || themeColors["upload-panel"] || "#7e8c73";
  const browseButtonColor = config?.browseButtonColor || themeColors["browse-button"] || "#c4c7a9";
  const uploadButtonColor = config?.uploadButtonColor || themeColors["upload-button"] || "#b3b89d";

  applyThemeObject({
    "upload-panel": uploadPanelColor,
    "browse-button": browseButtonColor,
    "upload-button": uploadButtonColor
  }, { persist: false });

  return theme;
}